import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../Contexts/AuthContext';

const SideNav = () => {
  const { user } = useAuth();
  const navigation = useNavigate();
  const handleClick = async (event: any) => {
    navigation(event.key);
  };

  if (user?.id != null) {
    return <span id="sider">

    </span>
  } else {
    return null;
  }
};

export default SideNav;